export default __webpack_public_path__ + "4c0248b11e23c54f04591737f6115eeb.svg";